import React, { forwardRef } from 'react';
// material-ui
import { Box, Stack, Grid, IconButton, Paper, Snackbar, SnackbarContent, LinearProgress } from '@mui/material';
import Typography from '@mui/material/Typography';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import LinkIcon from '@mui/icons-material/Link';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';

// project imports
import MainCard from 'components/MainCard';

import Autodesk from 'assets/images/auth/autodesk.webp';
import GoogleDrive from 'assets/images/auth/googledrive_result.webp';
import Redas from 'assets/images/auth/redas_result.webp';
import Synology from 'assets/images/auth/synology_logo_result.webp';
import SGBuildex from 'assets/images/auth/sgbuildex_result.webp';
import Excel from 'assets/images/auth/excel.png';

import { useEffect } from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import { useState } from 'react';
import {
  useConnections,
  useDeleteConnection,
  useConnectGoogleDrive,
  useConnectRedasConnection,
  useConnectSgbuildex,
  useConnectAutodesk
} from '../../hooks/useConnections';
import LoginRedasDialog from './component/loginRedas';
import LoginSGBuildexDialog from './component/loginSGBuildex';
import LoginSynologyDialog from './component/loginSynology';
import { renderLabelName } from '../../utils/getLabelConnectors';
import apiServices from '../../utils/axios';
import ConfirmDeleteDialog from '../../components/alert/alertDialog';

// ==============================|| SAMPLE PAGE ||============================== //

export default function ConnectorsPage() {
  const { data: dataConnection, isFetching: isLoadingConnection, isError } = useConnections();
  const { refetch: connectAutodesk, isError: isErrorConnectAutodesk } = useConnectAutodesk();
  const { mutate: connectGDrive, isPending: isCreatingConnection, isSuccess } = useConnectGoogleDrive();
  const { mutate: connectRedas, isPending: isCreatingConnRedas, isSuccess: isSuccessRedas } = useConnectRedasConnection();
  const { mutate: connectSgBuildex, isPending: isCreatingConnSgBuildex, isSuccess: isSuccessSgBuildex } = useConnectSgbuildex();
  const { mutate: deleteConnection, isPending: isDeletingConnection } = useDeleteConnection();

  const googleScopes = [
    'openid',
    'email',
    'profile',
    'https://www.googleapis.com/auth/spreadsheets.readonly',
    'https://www.googleapis.com/auth/drive.readonly',
    'https://www.googleapis.com/auth/drive.file'
  ].join(' ');

  const googleLogin = useGoogleLogin({
    flow: 'auth-code',
    scope: googleScopes,
    prompt: 'consent',
    access_type: 'offline',
    onSuccess: async (codeResponse) => {
      // After Google redirects back, FE receives code
      const code = codeResponse.code;
      await handleCreateConnection(code);
    }
  });

  const [open, setOpen] = React.useState(false);
  const [isloading, setisloading] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [openALertDialog, setopenALertDialog] = useState(false);
  const [labelAlertDialog, setlabelAlertDialog] = useState('');

  const [openLoginRedas, setopenRedas] = useState(false);
  const [openLoginSgBuildex, setopenSgBuildex] = useState(false);
  const [openLoginSynology, setopenSynology] = useState(false);

  const handleOpenLoginRedas = () => {
    setopenRedas(true);
  };

  const handleOpenLoginSGBuildex = () => {
    setopenSgBuildex(true);
  };

  const handleOpenLoginSynology = () => {
    setopenSynology(true);
  };

  const handleConfirmLoginRedas = (payload) => {
    console.log('login payload', payload);
    // call BE: POST /connections/manual
    const val = {
      username: payload.username,
      password: payload.password,
      project_id: payload.projectId
    };

    connectRedas(val, {
      onSuccess: () => {
        setOpen(true);
        setopenRedas(false);
      }
    });
  };

  const handleConfirmLoginSGBuildex = (payload) => {
    console.log('login payload', payload);
    // call BE: POST /connections/manual
    const val = {
      pitstop: payload.pitstop,
      access_token: payload.accesstoken
    };

    connectSgBuildex(val, {
      onSuccess: () => {
        setOpen(true);
        setopenSgBuildex(false);
      }
    });
  };

  const handleConfirmLoginSynology = (payload) => {
    console.log('login payload', payload);
    // call BE: POST /connections/manual
    setopenSynology(false);
  };

  const handleDeleteClick = ({ label, id }) => {
    setSelectedId(id);
    setlabelAlertDialog(label);
    setopenALertDialog(true);
  };

  const handleConfirm = () => {
    deleteConnection(selectedId, {
      onSuccess: () => {
        setopenALertDialog(false);
        setlabelAlertDialog('');
        setSelectedId(null);
      }
    });
  };

  const handleCreateConnection = (code) => {
    connectGDrive(code, {
      onSuccess: () => {
        setOpen(true);
      }
    });
  };

  const handleLoginConnectors = async ({ type, label }) => {
    setlabelAlertDialog(label);
    if (type === 'googledrive') {
      googleLogin();
    }
    if (type === 'autodesk') {
      const { data } = await connectAutodesk();
      // console.log(data)
      window.location.href = data.url;
      // const baseUrl = import.meta.env.VITE_BASE_URL_API
      // window.location.href = `${baseUrl}/aps/connection/create`;
    }
    if (type === 'redas') {
      handleOpenLoginRedas();
    }
    if (type === 'sgbuildex') {
      handleOpenLoginSGBuildex();
    }
    if (type === 'synology') {
      handleOpenLoginSynology();
    }
  };

  const handleClose = (_, reason) => {
    if (reason === 'clickaway') return;
    setOpen(false);
    setlabelAlertDialog('');
  };

  const isPageLoading = isCreatingConnection || isLoadingConnection || isCreatingConnRedas || isCreatingConnSgBuildex;

  return (
    <>
      {isPageLoading && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%'
          }}
        >
          <LinearProgress />
        </Box>
      )}

      <Box>
        <Snackbar open={open} onClose={handleClose} autoHideDuration={5000} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
          <SnackbarContent
            sx={{
              backgroundColor: '#fff',
              minWidth: 360,
              p: 2,
              boxShadow: 3,
              borderRadius: 1
            }}
            message={
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '100%'
                }}
              >
                {/* Left icon */}
                <CheckCircleIcon sx={{ mr: 2, fontSize: 28, color: 'success.dark' }} />

                {/* Center text */}
                <Box sx={{ flex: 1 }}>
                  <Typography fontWeight="bold" color="success.dark">
                    Add Connection Success
                  </Typography>
                  <Typography variant="subtitle2" color="text.primary">
                    {labelAlertDialog} is successfully added to your connector
                  </Typography>
                </Box>

                {/* Right close button */}
                <IconButton
                  size="small"
                  onClick={handleClose}
                  sx={{
                    ml: 2,
                    color: 'text.secondary'
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Box>
            }
          />
        </Snackbar>
        <Stack spacing={2}>
          <MainCard title="Choose your Data Connector :">
            <Grid container spacing={2}>
              {[
                { img: Autodesk, label: 'ACC', type: 'autodesk', max: 60 },
                { img: GoogleDrive, label: 'Google', type: 'googledrive', max: 60 },
                { img: Redas, label: 'Redas', type: 'redas', max: 60 },
                { img: SGBuildex, label: 'SGBuildex', type: 'sgbuildex', max: 50 },
                { img: Synology, label: 'Synology', type: 'synology', max: 100 }
              ].map((item, i) => (
                <Grid
                  size={{
                    xs: 12,
                    sm: 6,
                    md: 4,
                    lg: 2
                  }}
                  key={i}
                >
                  <Paper
                    elevation={2}
                    sx={{
                      cursor: 'pointer',
                      p: 2,
                      height: 130,
                      position: 'relative', // needed for overlay
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      transition: 'transform .25s, box-shadow .25s',
                      '&:hover': {
                        transform: 'translateY(-4px)',
                        boxShadow: 6
                      },
                      '&:hover .hoverLayer': {
                        opacity: 1
                      }
                    }}
                  >
                    {/* Hover Overlay */}
                    <Box
                      className="hoverLayer"
                      onClick={() => handleLoginConnectors(item)}
                      sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        bgcolor: 'rgba(255,255,255,0.7)',
                        backdropFilter: 'blur(6px)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        opacity: 0,
                        transition: 'opacity .3s',
                        borderRadius: 5
                      }}
                    >
                      <IconButton color="success">
                        <LinkIcon sx={{ fontSize: 40 }} />
                      </IconButton>
                    </Box>

                    <Box
                      sx={{
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: 72, // keep image area consistent
                        maxHeight: 72
                      }}
                    >
                      <Box
                        component="img"
                        src={item.img}
                        alt={item.label}
                        sx={{
                          width: '100%',
                          maxWidth: item.max,
                          height: 'auto',
                          objectFit: 'contain'
                        }}
                      />
                    </Box>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', mt: 1 }}>
                      {item.label}
                    </Typography>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </MainCard>
          <MainCard title="Other Supported Connections :">
            <Grid container spacing={2}>
              {[{ img: Excel, title: 'Excel', max: 60 }].map((item, i) => (
                <Grid
                  size={{
                    xs: 12,
                    sm: 6,
                    md: 4,
                    lg: 2
                  }}
                  key={i}
                >
                  <Paper
                    elevation={2}
                    sx={{
                      p: 2,
                      height: 130,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'space-between'
                    }}
                  >
                    <Box
                      sx={{
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: 72, // keep image area consistent
                        maxHeight: 72
                      }}
                    >
                      <Box
                        component="img"
                        src={item.img}
                        alt={item.title}
                        sx={{
                          width: '100%',
                          maxWidth: item.max,
                          height: 'auto',
                          objectFit: 'contain'
                        }}
                      />
                    </Box>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', mt: 1 }}>
                      {item.title}
                    </Typography>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </MainCard>
          <MainCard title="Connected Accounts :">
            <Grid container spacing={2}>
              {dataConnection?.map((item, i) => (
                <Grid
                  size={{
                    xs: 12,
                    sm: 6,
                    md: 4,
                    lg: 2
                  }}
                  key={i}
                >
                  <Paper
                    elevation={2}
                    sx={{
                      cursor: 'pointer',
                      p: 2,
                      height: 130,
                      position: 'relative', // needed for overlay
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      transition: 'transform .25s, box-shadow .25s',
                      '&:hover': {
                        transform: 'translateY(-4px)',
                        boxShadow: 6
                      },
                      '&:hover .hoverLayer': {
                        opacity: 1
                      }
                    }}
                  >
                    {/* Hover Overlay */}
                    <Box
                      onClick={() => handleDeleteClick(item)}
                      className="hoverLayer"
                      sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        bgcolor: 'rgba(255,255,255,0.7)',
                        backdropFilter: 'blur(6px)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        opacity: 0,
                        transition: 'opacity .3s',
                        borderRadius: 5
                      }}
                    >
                      <IconButton color="error">
                        <ExitToAppIcon sx={{ fontSize: 40 }} />
                      </IconButton>
                    </Box>

                    <Box
                      sx={{
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: 72, // keep image area consistent
                        maxHeight: 72
                      }}
                    >
                      <Box
                        component="img"
                        src={item.img}
                        alt={item.label}
                        sx={{
                          width: '100%',
                          maxWidth: item.max,
                          height: 'auto',
                          objectFit: 'contain'
                        }}
                      />
                    </Box>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', mt: 1 }}>
                      {renderLabelName(item)}
                    </Typography>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </MainCard>
        </Stack>
      </Box>

      <LoginRedasDialog open={openLoginRedas} onCancel={() => setopenRedas(false)} onConfirm={handleConfirmLoginRedas} />

      <LoginSGBuildexDialog open={openLoginSgBuildex} onCancel={() => setopenSgBuildex(false)} onConfirm={handleConfirmLoginSGBuildex} />

      <LoginSynologyDialog open={openLoginSynology} onCancel={() => setopenSynology(false)} onConfirm={handleConfirmLoginSynology} />

      <ConfirmDeleteDialog
        open={openALertDialog}
        loading={isDeletingConnection}
        onCancel={() => setopenALertDialog(false)}
        onConfirm={handleConfirm}
        description={`Are you sure you want to delete ${labelAlertDialog} connection?`}
      />
    </>
  );
}
